const inputTypes = {
  INPUT_TYPE_CHAT: 'INPUT_TYPE_CHAT',
  INPUT_TYPE_EMAIL: 'INPUT_TYPE_EMAIL',
  INPUT_TYPE_LOADING: 'INPUT_TYPE_LOADING',
  INPUT_TYPE_NAME: 'INPUT_TYPE_NAME',
  INPUT_TYPE_NONE: 'INPUT_TYPE_NONE',
  INPUT_TYPE_BACK: 'INPUT_TYPE_BACK',
  INPUT_TYPE_QUESTION: 'INPUT_TYPE_QUESTION',
  INPUT_TYPE_RESTART: 'INPUT_TYPE_RESTART',
} as const;

type Input = keyof typeof inputTypes;
export { inputTypes, type Input };
